import { SubscriptionsApi } from 'api/subscriptionsApi';
import { useCallback, useEffect, useState } from 'react';

export const useFetchRenewalSubscription = (id: number) => {
  const [subscription, setSubscription] = useState<any>(null);
  const [error, setError] = useState<string>('');

  const getRenewalSubscription = useCallback(async () => {
    const result = await SubscriptionsApi.getRenewalSubscription(id);

    if (result.data) {
      setSubscription(result.data);
    }

    if (result.error) {
      setError(result.error);
    }
  }, []);

  useEffect(() => {
    getRenewalSubscription();
  }, [getRenewalSubscription]);

  return { subscription, error };
};
